import ParseHtml from '@/lib/utils/parse-html'

type TextProps = {
  twoColumn?: 'yes' | 'no' | boolean
  heading?: string | null
  title?: string | null
  firstColumnText?: string | null
  text: string
}

export default function Text({
  twoColumn = false,
  heading = null,
  title = null,
  firstColumnText = null,
  text,
}: TextProps) {
  // Convert twoColumn to boolean
  if (typeof twoColumn === 'string') {
    twoColumn = twoColumn === 'yes' ? true : false
  }

  /*
  |--------------------------------------------------------------------------
  | Two column layout
  |--------------------------------------------------------------------------
  */
  if (twoColumn && firstColumnText) {
    return (
      <div className="component component--text style-lists custom-table">
        <div className="container">
          {heading || title ? (
            <div
              className={`${title ? 'mb-l' : 'mb-m'} flex flex-col gap-s @screen-ms-up/main:gap-s`}>
              {heading && (
                <span
                  className="p--small mb-0 block"
                  dangerouslySetInnerHTML={{ __html: heading }}></span>
              )}

              {title && <span className="h2" dangerouslySetInnerHTML={{ __html: title }}></span>}
            </div>
          ) : null}

          <div className="grid grid-cols-1 gap-l @screen-ms-up/main:grid-cols-2">
            <div>{firstColumnText ? <ParseHtml html={firstColumnText} /> : null}</div>

            <div>{text ? <ParseHtml html={text} /> : null}</div>
          </div>
        </div>
      </div>
    )
  }

  /*
  |--------------------------------------------------------------------------
  | One column layout
  |--------------------------------------------------------------------------
  */
  return (
    <div className="component component--text style-lists custom-table">
      <div className="container @container">
        <div className="flex justify-center border-gradient gradient-angle-[to_bottom] @is-child-of/single:!border-none @[0px]/single-simple:!border-0 @m-up:border-l @m-up:border-r">
          <div className="w-full @container @container/expand-tables @m-up:max-w-[var(--container-s-max-w)]">
            {text ? <ParseHtml html={text} /> : null}
          </div>
        </div>
      </div>
    </div>
  )
}
